module.exports = __webpack_public_path__ + "img/ws3.594663e3.jpg";